export default {
    manage_deleteCustomer_title: "Eliminar Cliente",
    manage_deleteCustomers_title: "Eliminar Clientes",
    manage_deleteCustomers_description: "¿Estás seguro de que quieres borrar los Clientes?",
    manage_deleteCustomer_description: "¿Está seguro de que desea eliminar este cliente?",
    manage_deleteCustomer_successMessage: "Cliente eliminado",
    manage_deleteCustomers_successMessage: "Clientes eliminados",
    manage_deleteCustomers_are_in_use: "No es posible eliminar clientes en uso",
}